// extracted by mini-css-extract-plugin
export default {"profile-onboarding":"OnBoarding_profile-onboarding__-7hho","caption":"OnBoarding_caption__dXK5H"};